import Vue from 'vue'
const alert = (type, message, options) => {
  Vue.swal({
    message: message,
    position: 'top',
    timer: 5000,
    showCloseButton: true,
    type: type,
    ...options,
  })
}
const toast = (type, title, options) => {
  Vue.swal({
    title: title,
    toast: true,
    position: 'top-end',
    showCloseButton: true,
    type: type,
    ...options,
  })
}
export default {
  methods: {
    alertSuccess(message, options = {}) {
      alert('success', message, options)
    },
    alertDanger(message, options = {}) {
      alert('error', message, options)
    },
    toastSuccess(title, options = {}) {
      toast('success', title, options)
    },
    toastDanger(title, options = {}) {
      toast('error', title, options)
    },
    toastInfo(title, options = {}) {
      toast('info', title, options)
    },
  },
}
